import './scss/label-size.scss';

export const LabelSize = (function () {
  let newModel = (lableSize = {}) => {
    return {
      width: lableSize.width ? lableSize.width : 0,
      height: lableSize.height ? lableSize.height : 0,
      measurementUnit: lableSize.measurementUnit ? lableSize.measurementUnit : 0
    };
  };

  let initView = (jQueryForm, lableSizeType, labelSize, elem) => {
    let template = require('./tmpl/label-size.hbs');
    $(elem).empty().html(template(labelSize));
    lableSizeType = lableSizeType;
    $('#labelSizeType', jQueryForm).select2({
      placeholder: $lang.trims.WhereIsLabelLocated
    });

    if (lableSizeType) {
      lableSizeType.forEach((val) => {
        var newOption = new Option(val, val, false, val == labelSize.measurementUnit);
        $('#labelSizeType', jQueryForm).append(newOption).trigger('change');
      });
    }
  };

  let returnLabelSize = (jQueryForm) => {
    var width = $('#labelSizeWidth', jQueryForm).val();
    var height = $('#labelSizeHeight', jQueryForm).val();
    var type = $('#labelSizeType', jQueryForm).val();
    return { Width: width, Height: height, measurementUnit: type };
  };

  return {
    newModel,
    initView,
    returnLabelSize
  };
})();
